import { useRef, useLayoutEffect } from "react";

//functionality to scroll to user's selection with smooth animation
export const useScrollToValue = (value: string) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const scrollToSelected = () => {
    const selectedItem = itemRefs.current[value];
    const container = containerRef.current;

    if (selectedItem && container) {
      const containerRect = container.getBoundingClientRect();
      const itemRect = selectedItem.getBoundingClientRect();
      const offset = itemRect.top - containerRect.top;

      container.scrollTo({
        top:
          container.scrollTop +
          offset -
          container.clientHeight / 2 +
          itemRect.height / 2,
        behavior: "smooth",
      });
    }
  };

  useLayoutEffect(() => {
    scrollToSelected();
  }, [value]);

  return {
    containerRef,
    itemRefs,
  };
};
